import { ulid } from 'ulid';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();
const LOCAL_PLAYER_ID_KEY = 'pendulumaster_player_id';

export class SessionManager {
  /**
   * LocalStorageからプレイヤーIDを取得
   * @returns {string|null} 保存されているプレイヤーID、または存在しない場合はnull
   */
  static getPlayerId() {
    return localStorage.getItem(LOCAL_PLAYER_ID_KEY);
  }
  
  /**
   * プレイヤーIDをLocalStorageに保存
   * @param {string} playerId 保存するプレイヤーID
   */
  static savePlayerId(playerId) {
    localStorage.setItem(LOCAL_PLAYER_ID_KEY, playerId);
  }
  
  /**
   * 現在のプレイヤーセッションを取得、または新しいセッションを作成
   */
  static async getOrCreateSession() {
    console.log('Getting or creating player session...');
    try {
      // LocalStorageからプレイヤーIDを取得
      const storedPlayerId = this.getPlayerId();
      
      if (storedPlayerId) {
        console.log('Existing player ID found:', storedPlayerId);
        // プレイヤーが存在するか確認
        try {
          const { data: player } = await client.models.Player.get({ playerId: storedPlayerId });
          if (player) {
            return {
              playerId: storedPlayerId,
              isNewUser: false
            };
          }
        } catch (error) {
          console.log('Player not found in database, will create new one');
          // プレイヤーが見つからない場合は新規作成
        }
      }
      
      // 新規プレイヤー作成
      return await this.createNewPlayer();
    } catch (error) {
      console.error('Error in getOrCreateSession:', error);
      // エラー時はローカルのみで動作するプレイヤーIDを生成または使用
      const playerId = this.getPlayerId() || `offline_${ulid()}`;
      this.savePlayerId(playerId);
      return {
        playerId: playerId,
        isNewUser: !this.getPlayerId(),
        offlineMode: true
      };
    }
  }
  
  /**
   * 新しいプレイヤーを作成
   */
  static async createNewPlayer() {
    // 新しいプレイヤーIDをulid()で生成
    const playerId = ulid();
    
    try {
      // Playerモデルに保存（最小限の情報のみ）
      await client.models.Player.create({
        playerId: playerId
      });
      
      // LocalStorageに保存
      this.savePlayerId(playerId);
      
      console.log('New player created with ID:', playerId);
      return {
        playerId: playerId,
        isNewUser: true
      };
    } catch (error) {
      console.error('Error creating new player:', error);
      // エラー時はローカルのみで動作するプレイヤーIDを生成
      this.savePlayerId(playerId);
      return {
        playerId: playerId,
        isNewUser: true,
        offlineMode: true
      };
    }
  }
}
